<div class="author-div">
    <mat-card *ngIf="!disabled" class="form-card">
        <mat-card-header>
            <mat-card-title>{{ 'DEUSTO.NEW_MENU.MENU_ITEMS.RECORDS.STEPS.AUTHORS.NEW_ITEM' | translate
                }}</mat-card-title>
            <div class="action-buttons">
                <button mat-raised-button color="primary" (click)="add()"
                    [disabled]="formGroup.invalid || addAuthorError?.length > 0"
                    [matTooltip]="'DEUSTO.NEW_MENU.MENU_ITEMS.RECORDS.STEPS.AUTHORS.ADD_ITEM' | translate">
                    <mat-icon>add</mat-icon>
                </button>
            </div>
        </mat-card-header>
        <mat-card-content>
            <form [formGroup]="formGroup">
                <mat-form-field class="w100">
                    <input type="text" matInput formControlName="search" [matAutocomplete]="auto"
                        [placeholder]="'SEARCH.INPUT.PLACEHOLDER' | translate">
                    <div matSuffix class="app-suffix-search-icon-wrapper">
                        <button mat-icon-button (click)="searchAuthor()">
                            <mat-icon>search</mat-icon>
                        </button>
                    </div>
                    <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn"
                        (optionSelected)="addGaudeAuthor($event.option.value)">
                        <mat-option *ngFor="let author of options" [value]="author"
                            [ngStyle]="isSelected(author, 'search') ? { 'background-color': '#f0f8ff'} : {}">
                            {{author.ria}} - {{author.nombre}} {{author.apellido1}} {{author.apellido2}}
                        </mat-option>
                    </mat-autocomplete>
                    <mat-error *ngIf="formGroup.get('search').hasError('minlength')">
                        {{ 'DEUSTO.NEW_MENU.MENU_ITEMS.RECORDS.STEPS.AUTHORS.MIN_LENGTH' | translate }}
                    </mat-error>
                </mat-form-field>

                <div class="spinner-center" *ngIf="loading">
                    <mat-spinner></mat-spinner>
                </div>
                <div *ngIf="!loading" class="formDiv">
                    <mat-form-field class="w100">
                        <mat-label>{{ 'DEUSTO.NEW_MENU.MENU_ITEMS.RECORDS.FIELDS.AUTHORS.NAME' | translate
                            }}</mat-label>
                        <input matInput formControlName="name">
                    </mat-form-field>

                    <mat-form-field class="w45">
                        <mat-label>{{ 'DEUSTO.NEW_MENU.MENU_ITEMS.RECORDS.FIELDS.AUTHORS.LASTNAME_1' | translate
                            }}</mat-label>
                        <input matInput formControlName="lastname1">
                    </mat-form-field>

                    <mat-form-field class="w45">
                        <mat-label>{{ 'DEUSTO.NEW_MENU.MENU_ITEMS.RECORDS.FIELDS.AUTHORS.LASTNAME_2' | translate
                            }}</mat-label>
                        <input matInput formControlName="lastname2">
                    </mat-form-field>

                    <mat-form-field [ngClass]="formGroup.get('gaudeId').value ? 'w45' : 'w100'">
                        <mat-label>{{ 'DEUSTO.NEW_MENU.MENU_ITEMS.RECORDS.FIELDS.AUTHORS.RIA' | translate
                            }}</mat-label>
                        <input matInput formControlName="ria">
                    </mat-form-field>

                    <mat-form-field class="w45" *ngIf="formGroup.get('gaudeId').value">
                        <mat-label>{{ 'DEUSTO.NEW_MENU.MENU_ITEMS.RECORDS.FIELDS.AUTHORS.ID' | translate
                            }}</mat-label>
                        <input matInput formControlName="gaudeId">
                    </mat-form-field>
                </div>
            </form>

            <mat-error>
                {{ addAuthorError | translate }}
            </mat-error>
        </mat-card-content>
    </mat-card>

    <form [formGroup]="group" [ngClass]="!disabled ? 'w50' : 'w100'" *ngIf="formArray.controls.length > 0">
        <div [formArrayName]="controlName">
            <mat-accordion>
                <div class="accordion-div" *ngFor="let control of formArray.controls; let i = index" [formGroupName]="i">
                    <mat-expansion-panel #panel class="expansion-panel"
                        [expanded]="i === formArray.controls.length-1 && formArray.controls.length === 1">
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                {{control.get('ria').value ? control.get('ria').value + ' - ' : ''}} {{control.get('name').value}}
                                {{control.get('lastname1').value ?? ''}} {{control.get('lastname2').value ?? ''}}
                            </mat-panel-title>
                            <mat-panel-description>
                                <mat-icon>{{ control.get('gaudeId').value ? 'assignment_ind' : 'person' }}</mat-icon>
                            </mat-panel-description>
                        </mat-expansion-panel-header>
        
                        <div class="div-wrap">
                            <mat-form-field class="w100">
                                <mat-label>{{ 'DEUSTO.NEW_MENU.MENU_ITEMS.RECORDS.FIELDS.AUTHORS.NAME' |
                                    translate
                                    }}</mat-label>
                                <input matInput formControlName="name">
                            </mat-form-field>

                            <mat-form-field class="w45">
                                <mat-label>{{ 'DEUSTO.NEW_MENU.MENU_ITEMS.RECORDS.FIELDS.AUTHORS.LASTNAME_1' |
                                    translate
                                    }}</mat-label>
                                <input matInput formControlName="lastname1">
                            </mat-form-field>

                            <mat-form-field class="w45">
                                <mat-label>{{ 'DEUSTO.NEW_MENU.MENU_ITEMS.RECORDS.FIELDS.AUTHORS.LASTNAME_2' |
                                    translate
                                    }}</mat-label>
                                <input matInput formControlName="lastname2">
                            </mat-form-field>

                            <mat-form-field [ngClass]="control.get('gaudeId').value ? 'w45' : 'w100'">
                                <mat-label>{{ 'DEUSTO.NEW_MENU.MENU_ITEMS.RECORDS.FIELDS.AUTHORS.RIA' |
                                    translate
                                    }}</mat-label>
                                <input matInput formControlName="ria">
                            </mat-form-field>

                            <mat-form-field *ngIf="control.get('gaudeId').value" class="w45">
                                <mat-label>{{ 'DEUSTO.NEW_MENU.MENU_ITEMS.RECORDS.FIELDS.AUTHORS.ID' |
                                    translate
                                    }}</mat-label>
                                <input matInput formControlName="gaudeId">
                            </mat-form-field>
                        </div>
        
                        <div class="action-buttons" *ngIf="!disabled">
                            <button mat-raised-button color="warn" (click)="delete(i)"
                                [matTooltip]="'DEUSTO.NEW_MENU.MENU_ITEMS.RECORDS.STEPS.AUTHORS.DELETE_ITEM' | translate">
                                <mat-icon>delete</mat-icon> {{ 'APP.ACTIONS.DELETE' | translate }}
                            </button>
                        </div>
                    </mat-expansion-panel>
                </div>
            </mat-accordion>
        </div>
    </form>

    <mat-card *ngIf="formArray.controls.length == 0" class="center">
        <mat-card-content>
            {{ 'DEUSTO.NEW_MENU.MENU_ITEMS.RECORDS.STEPS.AUTHORS.EMPTY_ITEM' | translate }}
        </mat-card-content>
    </mat-card>
</div>